const User = (props) => {
    return <svg width="16" height="16" className={props.className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 14.6667C2.44649 12.6021 5.08918 11.3333 8 11.3333C10.9108 11.3333 13.5535 12.6021 15.5 14.6667M11.75 4.25C11.75 6.32107 10.0711 8 8 8C5.92893 8 4.25 6.32107 4.25 4.25C4.25 2.17893 5.92893 0.5 8 0.5C10.0711 0.5 11.75 2.17893 11.75 4.25Z" stroke={props.color || "#475467"} strokeLinecap="round" strokeLinejoin="round" />
    </svg>;
}

export default User;